export interface PreselectedProduct {
  ApplicationTypeCode: string;
  AssessmentTypeCode: string;
  ProductNumber: string;
}
